export default __webpack_public_path__ + "static/media/fvsf.b7a6e6e4.png";